import * as d3 from "d3";

export interface ColourAction 
{
    element: d3.Selection<SVGElement, unknown, null, undefined>;
    color: string;
}

export class SearchFind
{
    private svg: d3.Selection<SVGSVGElement, unknown, null, undefined>;
    private g: d3.Selection<SVGGElement, unknown, null, undefined>;
    private image: d3.Selection<SVGGElement, unknown, null, undefined> | null;

    private selectedColourFill: string = "#000";
    private colourActions: Array<ColourAction> = [];

    private loadedImage: HTMLImageElement;

    private zoom: any;

    constructor(
        private container: HTMLDivElement,
        private imgSrc: string,
        private onCharacterFound: (id: string) => void,
        private characterIds: Array<string> = [],
        private zoomWidth: number,
        private zoomHeight: number
    )
    {
        this.loadedImage = document.createElement("img") as HTMLImageElement;
        this.loadedImage.onload = this.onImageReady.bind(this);
        this.loadedImage.src = imgSrc;
    }

    private onImageReady(): void 
    {
        this.init();
    }

    private init(): void 
    {
        this.svg = d3.select(this.container)
            .append("svg")
            .attr("width", "100%")
            .attr("height", "100%")
            .on("click", this.onSvgClicked.bind(this));

        this.g = this.svg.append("g");
        this.image = null;

        // Note: 1500x997 is what the actual visible SVG width/height is.
        this.zoom = d3.zoom()
            .scaleExtent([1, 2])
            // .translateExtent([[0, 0], [1500, 997]])
            .translateExtent([[0, 0], [this.zoomWidth, this.zoomHeight]])
            .on("zoom", this.handleZoom.bind(this));

        this.svg.call(this.zoom);

        this.loadSVG();
    }

    private onSvgClicked(e: MouseEvent): void 
    {
        // @ts-ignore
        const target = d3.select(e.target);

        let element = target.node();
        // @ts-ignore
        let id: string = element.id;

        if (this.characterIds.indexOf(id) > -1)
        {
            // We have a match
            this.onCharacterFound(id);
        }
    }

    private handleZoom(e: d3.D3ZoomEvent<SVGSVGElement, unknown>): void 
    {
        // @ts-ignore
        this.g.attr("transform", e.transform);
    }

    private loadSVG(): void
    {
        d3.svg(this.loadedImage.src).then((data) =>
        {
            this.image = this.g.append("g");

            const imageNode = this.image.node();

            if (imageNode)
            {
                const imageElement = d3.select(imageNode);

                imageElement.html(data.documentElement.outerHTML);

                d3.select('svg')
                    .call(this.zoom)
                    .call(this.zoom.scaleTo, 1);
            }
        });
    }
}